import { decode, encode } from "base-64";

const StringToB64 = (string: string) => {
  return `Basic ${encode(string)}`;
};

export { StringToB64 };
